import { Button, Flex, Form } from "antd";
import * as Icon from "@ant-design/icons";
import { verificarPermissaoEmpresa } from "../../util/functions/verificarPermissaoEmpresa";

type ButtonComponentProps = {
  onClick?: (value: any) => void;
  icon?: React.ReactNode;
  htmlType?: "button" | "submit" | "reset";
  children?: React.ReactNode;
  className?: string;
  props?: any;
};

export const ButtonComponent = ({ onClick, icon = <Icon.PlusCircleOutlined />, htmlType = "button", children = "CADASTRAR", className = "addButton buttonPrimary", props }: ButtonComponentProps) => {
  return (
    <Flex>
      {verificarPermissaoEmpresa() && (
        <Form.Item name="button" label=" ">
          <Button
            className={className}
            htmlType={htmlType}
            onClick={(value) => {
              onClick?.(value);
            }}
            icon={icon}
            {...props}
          >
            {children}
          </Button>
        </Form.Item>
      )}
    </Flex>
  );
};
